// GAVION team sessions: Rapports → « Sessions » (/rapports/sessions), administrateurs seulement.
export const sessionsFr = {
  title: "Sessions",
  description:
    "Qui appelle en ce moment, et chaque session d'appels de l'équipe.",
  error: "Impossible de charger les sessions.",
  not_found: "Cette session est introuvable.",
  live: {
    title: "En direct",
    none: "Personne n'est en session en ce moment.",
    count:
      "%{smart_count} représentant en session |||| %{smart_count} représentants en session",
    since: "Depuis %{time}",
    paused: "En pause",
    active: "Actif",
    current: "Compagnie en cours",
    no_current: "Aucune compagnie ouverte",
    auto_refresh: "Mise à jour automatique.",
    open_session: "Voir la session",
  },
  history: {
    title: "Historique",
    rep: "Représentant",
    all_reps: "Toute l'équipe",
    count: "%{smart_count} session |||| %{smart_count} sessions",
    empty: "Aucune session dans cette période.",
    start: "Début",
    end: "Fin",
    in_progress: "En cours",
    pagination: "Pages de l'historique",
    previous: "Précédent",
    next: "Suivant",
    page: "Page %{page} sur %{pages}",
  },
  metrics: {
    duration: "Durée",
    dials: "Appels",
    conversations: "Conversations",
    demos: "Démos",
    dials_per_hour: "Appels / heure",
    talk_time: "Temps de parole",
    totals: "Total de la période",
  },
  detail: {
    title: "Session de %{name}",
    title_fallback: "Session",
    back: "Retour aux sessions",
    range: "%{start} → %{end}",
    live: "Session en cours",
    calls: "Appels de la session",
    calls_empty: "Aucun appel dans cette session.",
    time: "Heure",
    lead: "Compagnie",
    contact: "Contact",
    outcome: "Résultat",
    talk: "Durée de parole",
    granola: "Note Granola",
    granola_link: "Ouvrir la note",
    granola_page: "Voir dans Réunions",
    open_call: "En cours",
    not_counted: "non compté",
  },
  dashboard: {
    title: "En session",
    none: "Personne n'est en session.",
    link: "Voir les sessions",
  },
  rep_link: "Voir ses sessions",
};
